import type { TourStep } from '@/components/ui/Tour';
import { COACH_CREATE_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** Add-coach drawer — contact, pay rate, and profile fields. */
export const coachCreateTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Add a coach"
        description="Create a coach record for scheduling, attendance, and optional portal access. You can send an invite after saving."
      />
    ),
    selectorId: COACH_CREATE_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Name and email"
        description="Use the coach's real work email. Portal invites, schedule notifications, and sign-in all depend on it — double-check for typos before you save."
      />
    ),
    selectorId: COACH_CREATE_TOUR_STEP_IDS.CONTACT,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Hourly rate and status"
        description="Enter an accurate hourly rate. Private lesson pricing, pay-by-attendance hours, and billing reports all use this figure. Set inactive coaches off the schedule without deleting them."
      />
    ),
    selectorId: COACH_CREATE_TOUR_STEP_IDS.COMPENSATION,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Bio and specialties"
        description="Optional profile details for your team list and lesson assignment context — juniors, adults, skill levels, and more."
      />
    ),
    selectorId: COACH_CREATE_TOUR_STEP_IDS.PROFILE,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Save the coach"
        description="Add the coach to your academy. You can send a portal invite from the coach card afterward when email invitations are enabled."
      />
    ),
    selectorId: COACH_CREATE_TOUR_STEP_IDS.SUBMIT,
    position: 'top',
  },
];
